module.exports = __webpack_public_path__ + "static/sitting-pretty_2008-735a241822101e98704fc0648d9ac907.jpg";